import{z as o}from"zod";const t=o.object({nonce:o.string()});export{t as BaseAccountTransferInput};
